export const SCENARIOS = [0, 4];
